import type { IDisposable } from './IDisposable';

export class AutoContext<T> implements IDisposable {
  private _context: T;

  private _disposer?: (resource: T) => void;

  public constructor(contextAcquireFn: () => T, disposer: (context: T) => void) {
    this._context = contextAcquireFn();
    this._disposer = disposer;
  }

  public dispose(): void {
    if (!this._disposer) {
      throw new Error('Already disposed');
    }
    this._disposer(this._context);
    this._disposer = undefined;
  }
}
